import {Controller} from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
    static targets = [ "iban", "bank", "bic" ];
    static values = { url: String };

    connect() {
        console.debug('Hello IBAN');
    }

    clear_bank() {
        let wrapper = $(this.ibanTarget).parent();
        $(this.bankTarget).val('');
        $(this.bicTarget).val('');
        wrapper.removeClass('error');
        wrapper.find('small.error').remove();
    }

    search_bank() {
        let iban = $(this.ibanTarget).val();
        let url = this.urlValue;
        fetch(`${url}?${new URLSearchParams({iban: iban})}`).then (data => {
            return data.json()})
            .then ((bank_data) => {
            console.debug(bank_data);
            if (bank_data.valid) {
                $(this.ibanTarget).removeClass('invalid');
                $(this.bankTarget).val(bank_data.bank);
                $(this.bicTarget).val(bank_data.bic);
            } else {
                $(this.ibanTarget).addClass('invalid');
                document.dispatchEvent(new CustomEvent('notify', {detail: {target: this.ibanTarget, msg: bank_data.msg, mode: 'errors'} }));
            }
        });
    }
}
